var version = "9.15.1";

export { version as v };
//# sourceMappingURL=package-1966467e.js.map
